import TicketHero from './view'

export default TicketHero
